export const getClassName = (isSelected: any) => {
  const className = "Tryb";
  if (isSelected) return className + "--selected";

  return className;
};
